import { render, staticRenderFns } from "./RetoureDetail.vue?vue&type=template&id=c778326c&scoped=true"
import script from "./RetoureDetail.vue?vue&type=script&lang=js"
export * from "./RetoureDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c778326c",
  null
  
)

export default component.exports